import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ShrinkLossReportRowFieldsFragment = { __typename?: 'ShrinkLossReportRow', reason?: Types.ShrinkType | null, itemId?: string | null, itemName?: string | null, categoryId?: string | null, categoryName?: string | null, week?: number | null, year?: number | null, locationId?: string | null, locationName?: string | null, shrinkQuantity: number, producedQuantity: number, percentOfProduced?: number | null, productionLotIds: Array<string> };

export type GetShrinkLossReportQueryVariables = Types.Exact<{
  input: Types.ShrinkLossReportInput;
}>;


export type GetShrinkLossReportQuery = { __typename?: 'Query', shrinkLossReport: { __typename?: 'ShrinkLossReport', rows: Array<{ __typename?: 'ShrinkLossReportRow', reason?: Types.ShrinkType | null, itemId?: string | null, itemName?: string | null, categoryId?: string | null, categoryName?: string | null, week?: number | null, year?: number | null, locationId?: string | null, locationName?: string | null, shrinkQuantity: number, producedQuantity: number, percentOfProduced?: number | null, productionLotIds: Array<string> }>, total: { __typename?: 'ShrinkLossReportRow', reason?: Types.ShrinkType | null, itemId?: string | null, itemName?: string | null, categoryId?: string | null, categoryName?: string | null, week?: number | null, year?: number | null, locationId?: string | null, locationName?: string | null, shrinkQuantity: number, producedQuantity: number, percentOfProduced?: number | null, productionLotIds: Array<string> } } };

export type GetProductionLotTimelineQueryVariables = Types.Exact<{
  productionLotId: Types.Scalars['String']['input'];
}>;


export type GetProductionLotTimelineQuery = { __typename?: 'Query', productionLotTimeline: Array<{ __typename?: 'ProductionLotTimelineEntry', at: Types.TDateISO, by?: string | null, kind: Types.ProductionLotTimelineKind, productionJobId?: string | null, quantity?: number | null, locationId?: string | null, locationName?: string | null, reason?: string | null, orderId?: string | null, orderNumber?: string | null, detail?: string | null }> };

export type GetShrinkLossLotsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  where?: Types.InputMaybe<Types.ProductionLotDocumentFilterInput>;
}>;


export type GetShrinkLossLotsQuery = { __typename?: 'Query', productionLots?: { __typename?: 'ProductionLotsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionLotDocument', productionLotId: string, lotNumber: number, productionPlanName: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetShrinkLossJobsQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ProductionJobDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionJobDocumentSortInput> | Types.ProductionJobDocumentSortInput>;
}>;


export type GetShrinkLossJobsQuery = { __typename?: 'Query', productionJobs?: { __typename?: 'ProductionJobsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionJobDocument', productionLotId: string, productionJobId: string, jobNumber: number, genus: string, series: string, color: string, locationName?: string | null, weekReadyIsoWeek: number, weekReadyIsoYear: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const ShrinkLossReportRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment ShrinkLossReportRowFields on ShrinkLossReportRow {
  reason
  itemId
  itemName
  categoryId
  categoryName
  week
  year
  locationId
  locationName
  shrinkQuantity
  producedQuantity
  percentOfProduced
  productionLotIds
}
    `, {"fragmentName":"ShrinkLossReportRowFields"});
export const GetShrinkLossReportDocument = new TypedDocumentString(`
    query GetShrinkLossReport($input: ShrinkLossReportInput!) {
  shrinkLossReport(input: $input) {
    rows {
      ...ShrinkLossReportRowFields
    }
    total {
      ...ShrinkLossReportRowFields
    }
  }
}
    fragment ShrinkLossReportRowFields on ShrinkLossReportRow {
  reason
  itemId
  itemName
  categoryId
  categoryName
  week
  year
  locationId
  locationName
  shrinkQuantity
  producedQuantity
  percentOfProduced
  productionLotIds
}`);
export const GetProductionLotTimelineDocument = new TypedDocumentString(`
    query GetProductionLotTimeline($productionLotId: String!) {
  productionLotTimeline(productionLotId: $productionLotId) {
    at
    by
    kind
    productionJobId
    quantity
    locationId
    locationName
    reason
    orderId
    orderNumber
    detail
  }
}
    `);
export const GetShrinkLossLotsDocument = new TypedDocumentString(`
    query GetShrinkLossLots($first: Int!, $where: ProductionLotDocumentFilterInput) {
  productionLots(first: $first, where: $where) {
    nodes {
      productionLotId
      lotNumber
      productionPlanName
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetShrinkLossJobsDocument = new TypedDocumentString(`
    query GetShrinkLossJobs($first: Int!, $after: String, $where: ProductionJobDocumentFilterInput, $order: [ProductionJobDocumentSortInput!]) {
  productionJobs(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      productionLotId
      productionJobId
      jobNumber
      genus
      series
      color
      locationName
      weekReadyIsoWeek
      weekReadyIsoYear
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetShrinkLossReport: build.query<GetShrinkLossReportQuery, GetShrinkLossReportQueryVariables>({
      query: (variables) => ({ document: GetShrinkLossReportDocument, variables })
    }),
    GetProductionLotTimeline: build.query<GetProductionLotTimelineQuery, GetProductionLotTimelineQueryVariables>({
      query: (variables) => ({ document: GetProductionLotTimelineDocument, variables })
    }),
    GetShrinkLossLots: build.query<GetShrinkLossLotsQuery, GetShrinkLossLotsQueryVariables>({
      query: (variables) => ({ document: GetShrinkLossLotsDocument, variables })
    }),
    GetShrinkLossJobs: build.query<GetShrinkLossJobsQuery, GetShrinkLossJobsQueryVariables>({
      query: (variables) => ({ document: GetShrinkLossJobsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetShrinkLossReportQuery, useLazyGetShrinkLossReportQuery, useGetProductionLotTimelineQuery, useLazyGetProductionLotTimelineQuery, useGetShrinkLossLotsQuery, useLazyGetShrinkLossLotsQuery, useGetShrinkLossJobsQuery, useLazyGetShrinkLossJobsQuery } = injectedRtkApi;
